export default "__VITE_ASSET__CnyE8PwE__"